import { render, staticRenderFns } from "./ReporteVentas.vue?vue&type=template&id=122aaa2c&scoped=true"
import script from "./ReporteVentas.vue?vue&type=script&lang=js"
export * from "./ReporteVentas.vue?vue&type=script&lang=js"
import style1 from "./ReporteVentas.vue?vue&type=style&index=1&id=122aaa2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122aaa2c",
  null
  
)

export default component.exports